export const ONativeToken = {
  eBTC: 'eBTC',
  LBTC: 'LBTC',
} as const;

export type TNativeToken = (typeof ONativeToken)[keyof typeof ONativeToken];

export const OLstToken = {
  LBTC: 'LBTC',
  eBTC: 'eBTC',
} as const;

export type TLstToken = (typeof OLstToken)[keyof typeof OLstToken];

export const stakableTokens: TNativeToken[] = [ONativeToken.eBTC, ONativeToken.LBTC];

export const stakableTokenConfig: Record<
  Exclude<TNativeToken, 'eBTC' | 'LBTC'>,
  {
    label: string;
    icon: React.ReactNode;
  }
> = {};

export type TStakableToken = (typeof stakableTokens)[number];
